import { render, staticRenderFns } from "./Customerservice.vue?vue&type=template&id=0b7313c4&"
import script from "./Customerservice.vue?vue&type=script&lang=js&"
export * from "./Customerservice.vue?vue&type=script&lang=js&"
import style0 from "./Customerservice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports